import { memo, useEffect, useState } from 'react'
import { useTranslate } from '../../../../../hooks/language/use-translate'

export const MessageSupport = memo(() => {
  const [shouldShow, setShouldShow] = useState(true)

  const { translate } = useTranslate()

  useEffect(() => {
    // if (!liveSetting?.messagePinnedChat) {
    const timeoutId = setTimeout(() => {
      setShouldShow(false)

      clearTimeout(timeoutId)
    }, 5000)
    // }
  }, [])
  // }, [liveSetting?.messagePinnedChat])

  if (!shouldShow) {
    return null
  }

  return (
    <div
      className="min-h-10 flex flex-row p-2 overflow-hidden rounded-lg w-72"
      style={{
        backgroundImage: 'linear-gradient(to right, #4568DC80, #3B478180)',
      }}
    >
      <span className="break-all text-[13px]">
        {translate('chat-live-message-support')}
      </span>
    </div>
  )
})
